import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@mui/material";

import "./styles/Status.css";

// metrics object elements:
// suffix
// actualValue
// etcValue
// eacValue
// budgetValue
// diffValue
// pctComplete

function StatusProjectMetricsBigNumbers(props) {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box className="statusTableTitle">Project Metrics</Box>
      <Table className="statusTable">
        <TableBody>
          <TableRow className="statusTableHeaderRow">
            <TableCell className="statusTableColumnHeader">Metric</TableCell>
            <TableCell className="statusTableColumnHeader">Value</TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">
              Actual {props.metricsObject.suffix}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.actualValue}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">
              ETC {props.metricsObject.suffix}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.etcValue}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">
              EAC {props.metricsObject.suffix}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.eacValue}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">
              Budget {props.metricsObject.suffix}
            </TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.budgetValue}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">Difference</TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.diffValue}
            </TableCell>
          </TableRow>
          <TableRow className="statusTableRow">
            <TableCell className="statusTableCell">% Complete</TableCell>
            <TableCell className="statusTableCell">
              {props.metricsObject.pctComplete}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
}

export default StatusProjectMetricsBigNumbers;

StatusProjectMetricsBigNumbers.propTypes = {
  metricsObject: PropTypes.object,
};

/*
     <table className="statusTable">
        <tr className="statusTableRow">
          <td className="statusTableColumnHeader">Metric</td>
          <td className="statusTableColumnHeader">Value</td>
        </tr>
        <tr className="statusTableRow">
          <td className="statusTableCell">
            Actual {props.metricsObject.suffix}
          </td>
          <td className="statusTableCell">{props.metricsObject.actualValue}</td>
        </tr>
      </table>
      */
